import { Typography } from "@mui/material";
import { NotificationType } from "generated/CoreApi_v1";
import { ReactNode } from "react";
import { Link } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { LmsPaths } from "routes/LmsRouter";
import { MessengerResolver } from "views/foundation/notification/resolvers/MessengerResolver";

////////////////////////////////////////////////////////////////////////////////

export class AwardResolver extends MessengerResolver {

    static messengerId: string[] = [
        "Award.*",
    ];

    protected translateAction(): ReactNode {
        if (this.notificationActionKeys == null)
            return this.notificationAction?.title ?? "?";

        switch (this.notification.notificationTypeId) {
            case NotificationType.AwardAnswerQuestion:
                return <Link to={KnowledgePaths.QuestionViewer(this.notificationActionKeys![0])} onClick={() => this.onCloseMenu()}>
                    <Typography variant="linkAction">{this.notificationAction!.title}</Typography>
                </Link>;

            case NotificationType.AwardChallenge:
                //TODO: Direcionar para dashboard de desafios de conhecimento (não implementado ainda)
                return <b>{this.notificationAction?.title ?? ""}</b>;

            case NotificationType.AwardCreatePublication:
                return <Link to={KnowledgePaths.PublicationViewerResolver(this.notificationActionKeys![0], this.notificationActionKeys![1])} onClick={() => this.onCloseMenu()}>
                    <Typography variant="linkAction">{this.notificationAction!.title}</Typography>
                </Link>;

            case NotificationType.AwardLmsTrainingApproved:
                return <Link to={LmsPaths.BuildTrainingViewer(this.notificationActionKeys![0])} onClick={() => this.onCloseMenu()}>
                    <Typography variant="linkAction">{this.notificationAction!.title}</Typography>
                </Link>;

            case NotificationType.AwardLmsTrainingEnrolled:
                return <Link to={LmsPaths.BuildTrainingViewer(this.notificationActionKeys![0])} onClick={() => this.onCloseMenu()}>
                    <Typography variant="linkAction">{this.notificationAction!.title}</Typography>
                </Link>;
        }

        return "???";
    }
}
